import React from 'react'
import { CustomTitle } from 'src/components'
import { getUserAdminName } from 'src/core/helpers'
import { UsersAdmin } from 'src/core/models'

const UserAdminNameColumn: React.FC<{ user: UsersAdmin }> = ({ user }) => {
  const name = getUserAdminName(user)

  return <CustomTitle label={name} type={null} />
}

export default UserAdminNameColumn
